import { useEffect, useState } from "react";
import { History, Search, X } from "lucide-react";
import { api } from "@/lib/api";
import { Pagination, usePagination } from "@/components/Pagination";

const TYPE_CLASS = { "Penjualan": "mv-sale", "Pembelian": "mv-buy", "Stok Opname": "mv-opname", "Transfer Keluar": "mv-transfer", "Transfer Masuk": "mv-transfer", "Produksi (Bahan)": "mv-prod", "Produksi (Jadi)": "mv-prod" };
const fmtDate = (d) => (d ? d.split("-").reverse().join("/") : "—");

export default function StockHistory() {
  const [rows, setRows] = useState([]);
  const [products, setProducts] = useState([]);
  const [productId, setProductId] = useState("");
  const [type, setType] = useState("");
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState(null);
  useEffect(() => {
    setLoading(true);
    api(`/inventory/movements${productId ? `?product_id=${productId}` : ""}`).then(setRows).catch((e) => setMessage({ text: e.message, type: "error" })).finally(() => setLoading(false));
  }, [productId]);
  useEffect(() => { api("/products").then((ps) => setProducts(ps.filter((p) => p.type !== "Service"))).catch(() => {}); }, []);
  const filtered = rows.filter((r) => (!type || r.type === type) && [r.reference, r.product_name, r.warehouse, r.note, r.type].join(" ").toLowerCase().includes(search.toLowerCase()));
  const pager = usePagination(filtered, 25, `${productId}|${type}|${search}`);
  const types = [...new Set(rows.map((r) => r.type))];
  return (
    <div className="workflow-page">
      <div className="page-heading">
        <div><p className="eyebrow">PRODUK & GUDANG</p><h1>Riwayat Stok</h1><p className="muted">Seluruh pergerakan stok dari penjualan, pembelian, opname, transfer gudang, dan produksi.</p></div>
      </div>
      {message && <div data-testid="mv-error-message" className="success-message error">{message.text}<button onClick={() => setMessage(null)}><X size={14} /></button></div>}
      <div className="workflow-toolbar surface mv-toolbar">
        <div className="workflow-search"><Search size={16} /><input data-testid="mv-search-input" placeholder="Cari nomor, produk, gudang..." value={search} onChange={(e) => setSearch(e.target.value)} /></div>
        <div className="mv-filters">
          <select data-testid="mv-filter-product" value={productId} onChange={(e) => setProductId(e.target.value)}>
            <option value="">Semua produk</option>
            {products.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
          <select data-testid="mv-filter-type" value={type} onChange={(e) => setType(e.target.value)}>
            <option value="">Semua tipe</option>
            {types.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
          <span className="record-count">{filtered.length} pergerakan</span>
        </div>
      </div>
      <div className="surface workflow-table-wrap">
        <table className="workflow-table" data-testid="mv-table">
          <thead><tr><th>TANGGAL</th><th>TIPE</th><th>REFERENSI</th><th>PRODUK</th><th>GUDANG</th><th className="right">MASUK</th><th className="right">KELUAR</th><th>KETERANGAN</th></tr></thead>
          <tbody>
            {pager.pageItems.map((r, i) => (
              <tr key={`${r.reference}-${r.product_id}-${i}`}>
                <td>{fmtDate(r.date)}</td>
                <td><span className={`mv-badge ${TYPE_CLASS[r.type] || ""}`}>{r.type}</span></td>
                <td className="primary-cell">{r.reference}</td>
                <td>{r.product_name}</td>
                <td>{r.warehouse || "—"}</td>
                <td className="right mono mv-in">{r.qty > 0 ? `+${r.qty}` : ""}</td>
                <td className="right mono mv-out">{r.qty < 0 ? r.qty : ""}</td>
                <td className="mv-note">{r.note || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!loading && filtered.length === 0 && <div className="empty-state" data-testid="mv-empty-state"><History size={25} /><strong>Belum ada pergerakan stok</strong><span>Transaksi penjualan, pembelian, opname, transfer, dan produksi akan tercatat di sini.</span></div>}
        {loading && <div className="empty-state"><strong>Memuat riwayat stok...</strong></div>}
        <Pagination pager={pager} testid="mv-pagination" />
      </div>
    </div>
  );
}
